<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="all-but-won">
<h1>All but Won</h1>
<p style="text-indent:0px;">People who doubt you,</p>
<p style="text-indent:0px;">They doubt themselves.</p>
<p style="text-indent:0px;">Friends that were once true,</p>
<p style="text-indent:0px;">Are dusty books on old shelves.</p><br/>
<p style="text-indent:0px;">As you grow older,</p>
<p style="text-indent:0px;">Life teaches your things.</p>
<p style="text-indent:0px;">You learn to be bolder,</p>
<p style="text-indent:0px;">Get rid of negative beings.</p><br/>
<p style="text-indent:0px;">Truth of the universe,</p>
<p style="text-indent:0px;">You carry within.</p>
<p style="text-indent:0px;">Even if life seems a curse,</p>
<p style="text-indent:0px;">Even if prospects are slim.</p><br/>
<p style="text-indent:0px;">Do not carry anger,</p>
<p style="text-indent:0px;">It’s not worth your time.</p>
<p style="text-indent:0px;">You will not be in danger,</p>
<p style="text-indent:0px;">You will be just fine.</p><br/>
<p style="text-indent:0px;">Let go of your past,</p>
<p style="text-indent:0px;">You never made bad choices.</p>
<p style="text-indent:0px;">They were lessons that last,</p>
<p style="text-indent:0px;">Guided by unseen voices…</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch014.vue?14bbdae2